module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-arrange-b88055d69afb038660e2a21cee52ba2e.svg";